export default {
  title: {
    en: 'Shop',
  },
  shop: {
    en: 'Shop',
  },
  sendAGift: {
    en: 'Send a Gift',
  },
  shopPerfumes: {
    en: 'Shop perfumes',
  },
  shopColognes: {
    en: 'Shop colognes',
  },
  upgrade: {
    en: 'Upgrade',
  },
}
